export var FunnelStage;
(function (FunnelStage) {
    FunnelStage["VISIT"] = "visit";
    FunnelStage["WIDGET_OPEN"] = "widget_open";
    FunnelStage["DEMO_START"] = "demo_start";
    FunnelStage["DEMO_COMPLETE"] = "demo_complete";
    FunnelStage["CTA_CLICK"] = "cta_click";
    FunnelStage["MEETING_BOOKED"] = "meeting_booked";
    FunnelStage["LEAD_CREATED"] = "lead_created";
})(FunnelStage || (FunnelStage = {}));
//# sourceMappingURL=analytics.js.map